module.exports = __webpack_public_path__ + "img/totalRegisters.d1f53ab1.svg";